import { Button } from "@freightsimple/ui-core/Controls/Button";
import { ControlPresentationProvider } from "@freightsimple/ui-core/Controls/ControlPresentationProvider";
import { CopyToClipboardButton } from "@freightsimple/ui-core/Buttons/CopyToClipboardButton";
import { Dialog } from "@freightsimple/ui-core/Dialog/Dialog";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import { CopyableLinkBox } from "@/Shared/Components/CustomComponents/CopyableLinkBox";
import type { UUID } from "@/Shared/types";
import { rootUrl } from "@/Environment";

interface ViewShipmentsShareTrackingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trackingId: UUID;
}

// Share-tracking-link dialog: the public tracking URL with copy-to-clipboard.
export function ViewShipmentsShareTrackingDialog(
  props: ViewShipmentsShareTrackingDialogProps,
) {
  const trackingUrl = `${rootUrl()}t?tId=${props.trackingId}`;

  return (
    <Dialog
      open={props.open}
      onOpenChange={props.onOpenChange}
      title="Share Shipment Information"
      description="You can send this link to someone who doesn't have an account with FreightSimple. This will allow them to get all the information they need for pickup or delivery"
      width="medium"
      footer={
        <Button primary onClick={() => props.onOpenChange(false)}>
          Done
        </Button>
      }
    >
      <ControlPresentationProvider presentation="underlined">
        {/* The box carries the link and the button carries the affordance — a
            bare value with a trailing copy icon read as prose and the icon went
            unnoticed. Same pair as the referral and credit-card dialogs. */}
        <Stack align="start" gap={2}>
          <Row gap={3} shrinkable>
            <CopyableLinkBox url={trackingUrl} />
            <CopyToClipboardButton
              data={trackingUrl}
              label="Tracking link"
              size="link"
            >
              Click here to copy to clipboard
            </CopyToClipboardButton>
          </Row>
          <T size="sm" color="secondary">
            Please note, this does not share billing information with them
          </T>
        </Stack>
      </ControlPresentationProvider>
    </Dialog>
  );
}
